import styled from 'styled-components'
import WidgetContainer from './WidgetContainer'

export default styled(WidgetContainer)`
  flex-basis: 50%;
`
